import type { AuthUserFieldsFragment } from '~/graphql/generated/graphql';

export const APP_TYPE = <const>{
  CONTENT: 'content',
  SCHOOLS: 'schools',
  UNIFIED: 'unified',
  ROOT: 'root',
};

export type AppType = (typeof APP_TYPE)[keyof typeof APP_TYPE];

export interface AppConfig {
  appType: AppType;
  userHasRequiredRole: (user: AuthUserFieldsFragment) => boolean;
  // Cluster-relative paths (e.g. `/content/login`). Wrap at the navigation
  // site with `clusterRedirectPath()` for SPA nav or `clusterUrl()` for
  // external nav — see composables/core.ts.
  unAuthenticatedRedirectRoute: string;
  dashboardRedirectRoute: string;
  logoutRedirectRoute: string;
  onErrorRedirectRoute: string;
  accountRoute: string;
  registerDisabledHelpTextKey?: string;
}
